import { SHStack } from "@components/design-systems";
import { AnalysisDataDTO } from "@models/platform-analysis/entities/steps/feature";
import { FeatureAnalysisRowLevel } from "@models/platform-analysis/enums/feature/featureAnalysisRowLevel";
import { useTheme } from "@mui/material";
import { memo, useMemo } from "react";
import { RenderedProductCellComponentMap } from "../../../../configs";

interface RenderedProductCellContainerProps {
  name: string;
  analysisData: AnalysisDataDTO;
  level: FeatureAnalysisRowLevel;
  forceCellColor?: string;
}

export const RenderedProductCellContainer = memo(
  ({
    analysisData,
    level,
    name,
    forceCellColor,
  }: RenderedProductCellContainerProps) => {
    const { palette } = useTheme();

    const cellBackGroundColor =
      forceCellColor && level !== FeatureAnalysisRowLevel.Section
        ? `${forceCellColor} !important`
        : "inherit";

    const RenderCellComponent = useMemo(
      () => RenderedProductCellComponentMap[level],
      [level],
    );

    return (
      <SHStack
        className={`FeatureAnalysisRenderedCell FeatureAnalysisRenderedCell-${level}`}
        width={"100%"}
        height={"100%"}
        border={`1px solid ${palette.secondary[100]}`}
        borderBottom={"none"}
        borderLeft={"none"}
        justifyContent={"center"}
        alignItems={"center"}
        paddingX={"10px"}
        bgcolor={cellBackGroundColor}
      >
        <RenderCellComponent analysisData={analysisData} name={name} />
      </SHStack>
    );
  },
);
